var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { Component, Input, Output, EventEmitter, Inject } from '@angular/core';
import * as _ from 'lodash';
import { finalize } from 'rxjs/operators';
import { VariableName } from '../../../core/variable/variable-name';
import { VARIABLE_SERVICE } from '../../../core/variable/variable.service';
import { VariableVersion } from '../../../core/variable/variable-version';
import { AppComponentBase } from '../../../../../shared/app-component-base';
import { ChooseMonitorComponent } from '../monitor/choose-monitors.component';
var VariableSelectorComponent = /** @class */ (function (_super) {
    __extends(VariableSelectorComponent, _super);
    function VariableSelectorComponent(injector, modalService, variableService) {
        var _this = _super.call(this, injector) || this;
        _this.modalService = modalService;
        _this.variableService = variableService;
        _this.loading = false;
        _this.currentVariableIdChange = new EventEmitter();
        return _this;
    }
    Object.defineProperty(VariableSelectorComponent.prototype, "currentVariableId", {
        get: function () {
            return this._currentVariableId;
        },
        set: function (v) {
            if (VariableName.equals(this._currentVariableId, v)) {
                return;
            }
            this._currentVariableId = v;
            if (v !== undefined) {
                this.selectedVariable = v;
            }
            else {
                this.selectedVariable = undefined;
            }
        },
        enumerable: true,
        configurable: true
    });
    VariableSelectorComponent.prototype.showChooseMonitor = function ($event) {
        $event.preventDefault();
        this.showConditionModal();
    };
    VariableSelectorComponent.prototype.showConditionModal = function () {
        var _this = this;
        var modalRef = this.modalService.show(ChooseMonitorComponent, {
            initialState: {
                dataType: this.dataType,
                readWriteModel: this.readWriteModel,
                selectedVariable: this.selectedVariable,
                configureId: this.configureId
            },
            backdrop: 'static',
            class: 'choose-monitor'
        });
        var onClosedSub = modalRef.content.onClosed.subscribe(function (result) {
            if (result) {
                _this.selectedVariable = result;
                _this.getDetailSelectedVariable();
            }
            onClosedSub.unsubscribe();
        });
    };
    VariableSelectorComponent.prototype.ngOnInit = function () {
        this.loadVaribales();
    };
    VariableSelectorComponent.prototype.loadVaribales = function () {
        var _this = this;
        this.loading = true;
        this.variableService.getVariablesName(this.dataType, this.readWriteModel)
            .pipe(finalize(function () { _this.loading = false; }))
            .subscribe(function (variables) {
            _this.variableItems = _.map(variables, function (item) { return ({
                name: item.name,
                variableVersion: VariableVersion.variableVersion,
                groupName: item.groupName
            }); });
            var isFindSelectedVariable = false;
            _this.variableItems.forEach(function (v) {
                if (v && _this.selectedVariable && v.name === _this.selectedVariable.name) {
                    isFindSelectedVariable = true;
                }
            });
            if (!isFindSelectedVariable) {
                _this.selectedVariable = undefined;
            }
        });
    };
    VariableSelectorComponent.prototype.compareWith = function (x, y) {
        if (!x.name || !y.name) {
            return false;
        }
        return VariableName.equals(x, y);
    };
    VariableSelectorComponent.prototype.getDetailSelectedVariable = function () {
        this.refreshCurrentVariableId();
    };
    VariableSelectorComponent.prototype.groupByFn = function (item) {
        return item.groupName;
    };
    VariableSelectorComponent.prototype.refreshCurrentVariableId = function () {
        if (VariableName.equals(this._currentVariableId, this.selectedVariable)) {
            return;
        }
        this._currentVariableId = this.selectedVariable;
        this.currentVariableIdChange.emit(this.selectedVariable);
    };
    __decorate([
        Input()
    ], VariableSelectorComponent.prototype, "configureId", void 0);
    __decorate([
        Input()
    ], VariableSelectorComponent.prototype, "currentVariableId", null);
    __decorate([
        Output()
    ], VariableSelectorComponent.prototype, "currentVariableIdChange", void 0);
    __decorate([
        Input()
    ], VariableSelectorComponent.prototype, "dataType", void 0);
    __decorate([
        Input()
    ], VariableSelectorComponent.prototype, "readWriteModel", void 0);
    VariableSelectorComponent = __decorate([
        Component({
            selector: 'variable-selector',
            styles: [".variable-input{ width: 100%; .variable-select{ width: calc(100% - 30px); float: left; color: rgba(0, 0, 0, 0.3); line-height: 30px; } .open-monitor-btn{ width: 30px; height: 30px; line-height: 25px; float: left; background-color: white; border: 1px solid #d7dbe5; border-left: 0; cursor: pointer; span { color: #3695FF; } } .ng-select{ margin-left: 0 !important; } }"],
            template: "<div class=\"variable-input clearfix designer-input-wrap\"> <ng-select name=\"refVariable\" class=\"variable-select\" [items]=\"variableItems\" bindLabel=\"name\" [groupBy]=\"groupByFn\" [(ngModel)]=\"selectedVariable\" [clearable]=\"true\" [loading]=\"loading\" [loadingText]=\"l('LoadWithThreeDot')\" [compareWith]=\"compareWith\" [notFoundText]=\"l('NoData')\" (change)=\"getDetailSelectedVariable()\"> <ng-template ng-label-tmp let-item=\"item\"> {{item.name + '(' + item.groupName + ')'}} </ng-template> </ng-select> <button type=\"button\" class=\"open-monitor-btn\" (click)=\"showChooseMonitor($event)\"><span class=\"fa fa-bars\"></span></button> </div> "
        }),
        __param(2, Inject(VARIABLE_SERVICE))
    ], VariableSelectorComponent);
    return VariableSelectorComponent;
}(AppComponentBase));
export { VariableSelectorComponent };
